const ko_KR = {
  'hello': 'Hello',
  "App.Footer.noteText": "The exact train location could be different from the displayed one",
  "App.Train.significantlyDelayed": "장시간 지연",
  "App.ModalDialog.headerTitle": "열차 정보",
  "App.ModalDialog.cars": "차량",
  "App.ModalDialog.currently": "현재지",
  "App.ModalDialog.onTime": "지연 없음",
  "App.ModalDialog.minLate": "분 지연",
  "App.ModalDialog.significantlyDelayed": "장시간 지연",
  "App.ModalDialog.trainStops": "정차역",
  "App.ModalDialog.arrivesScheduled": "도착 시간(정각)",
  "App.ModalDialog.estimated": "(추정)",
  "App.ModalDialog.doesNotStop": "통과",
  "App.ModalDialog.sorryArrivalTimeNotAvailable": "대단히 죄송합니다.\r\n현재 도착 시간을 표시할 수 없습니다.",
  "App.ModalDialog.arrivalTimeNotAvailable": "현재 도착 시간을 표시할 수 없습니다.",
  "App.ModalDialog.furtherArrivalTimeNotAvailable": "현재 도착 시간을 표시할 수 없습니다.",
  "App.ModalDialog.kindOrDestinationsMayChange": "※종별, 목적지 등은 변경되는 경우가 있습니다.",
  "App.TrainPositions.enableAutoRefresh": "자동 업데이트를 활성화합니다",
  "App.TrainPositions.disableAutoRefresh": "자동 업데이트를 비활성화합니다",
  "App.TrainPositions.thruToJR": "사이쿄선{br}・가와고에선 직통",
  "App.TrainPositions.thruToTokyu": "도요코선・메구로선직통",
  "App.TrainPositions.thruToToyoko": "도요코선 경유",
  "App.TrainPositions.thruToMeguro": "메구로선 경유",
  "App.TrainPositions.thruToFukutoshin": "후쿠토신선직통",
  "App.TrainPositions.thruToNambokuMita": "난보쿠선・미타선직통",
  "App.TrainPositions.kindModal.title": "범례",
  "App.TrainPositions.footer.actualMayDiffer": "실제 열차 위치, 종별, 목적지, 차량수, 지연 시간과 다를 수 있습니다.",
  "App.TrainPositions.footer.displayTime": "화면 표시 시간",
  "App.TrainPositions.dialog.outsideArea": "소테츠선 이외의 지역입니다",  
  "App.RouteMap.kindModal.title": "범례",
  "App.RouteMap.kindModal.noteComLtdExpAndComExpStops": "○：통근특급・통근급행 정차역",
  "App.RouteMap.kindModal.noteComLtdExpStops": "△：통근특급 는 츠루가미네 에 정차",
  "App.TransferModal.transferRoute": "환승 노선",
  "StationDetail.stationMap": "구내도",
  "StationDetail.stopPositions": "승강장 정차 위치",
  "StationDetail.thruToJR": "사이쿄선・가와고에선 직통",
  "StationDetail.thruToToyoko": "도요코선 경유",
  "StationDetail.thruToMeguro": "메구로선 경유",
  "StationDetail.checkCongestionSituation": "역의 혼잡 상황을{br}확인할 수 있습니다",
  "StationDetail.stationView": "역 전경",
  "Timetable.trackNo": "승강장",
  "Timetable.trainKind": "종별",
  "Timetable.destination": "목적지",
  "Timetable.depTime": "발차 시간",
  "Timetable.cars": "차량수",
  "TermsDetail.pageTitle": "사가미 앱 이용규약",
  "TermsDetail.title": "머리말",
  "TermsDetail.abstract": "“사가미 앱 이용규약”(이하 ‘본 규약’이라고 함)은 사가미철도 주식회사(이하 ‘사가미 철도’라고 함)가 제공하는 스마트폰용 앱 “사가미 앱”(이하 ‘본 앱’이라고 함 )의 이용자(이하 ‘이용자’라고 함)에 대한 제공 조건 및 본 앱의 이용에 관한 이용자와 사가미 철도 간의 권리 의무에 대해 정하는 것입니다.",
  "TermsDetail.article1": "제1조 규약의 적용",
  "TermsDetail.paragraph1_1": "이용자는 본 규약에 동의한 후 본 앱을 이용하는 것으로 합니다. 본 규약에 동의를 얻을 수 없는 경우는 본 앱을 이용할 수 없습니다.",
  "TermsDetail.paragraph1_2": "본 규약은 본 앱의 제공 조건 및 본 앱의 이용에 관한 이용자와 사가미 철도 간의 권리 의무를 정하는 것으로, 이용자와 사가미 철도 간의 본 앱 이용과 관련한 모든 관계에 적용됩니다.",
  "TermsDetail.paragraph1_3": "본 규약의 내용과 그 외의 본 규약 외에 있어서 본 앱의 설명 등이 다른 경우는 본 규약 내용이 우선적으로 적용됩니다.",
  "TermsDetail.article2": "제2조 본 앱의 목적",
  "TermsDetail.paragraph2_1": "본 앱은 인터넷을 통하여 사가미 철도의 운행 정보나 사가미 철도(그룹 회사를 포함)의 이벤트 정보 등을 제공하는 것입니다.",
  "TermsDetail.article3": "제3조 이용 요금",
  "TermsDetail.paragraph3_1": "본 앱의 이용 요금은 무료입니다. 다만, 본 앱의 다운로드 및 이용과 관련되는 통신료는 이용자가 부담하는 것으로 합니다.",
  "TermsDetail.article4": "제4조 이용 환경",
  "TermsDetail.paragraph4_1": "본 앱의 이용에 필요한 기기, 소프트웨어, 인터넷 접속, 전화 회선 등은 이용자가 자신의 책임과 부담으로 준비하는 것으로 합니다.",
  "TermsDetail.article5": "제5조 지적 재산권",
  "TermsDetail.paragraph5_1": "본 앱의 콘텐츠에 관한 저작권 및 그 외의 지적 재산권은 모두 사가미 철도 또는 사가미 철도가 지정하는 자에게 귀속합니다.",
  "TermsDetail.article6": "제6조 본 앱의 변경 및 종료",
  "TermsDetail.paragraph6_1": "사가미 철도는 사전의 예고 없이 본 앱의 전부 또는 일부를 변경, 추가, 삭제할 수 있습니다.",
  "TermsDetail.paragraph6_2": "사가미 철도는 사전의 예고 없이 본 앱의 제공, 업데이트를 종료할 수 있습니다.",
  "TermsDetail.article7": "제7조 면책 사항",
  "TermsDetail.paragraph7_1": "사가미 철도는 이용자에 대해 본 앱의 정확한 작동 및 모든 기능이 발휘되는 것을 보증하는 것이 아닙니다.",
  "TermsDetail.paragraph7_2": "사가미 철도는 본 앱에서 정확한 정보를 제공하기 위해 노력하지만, 정보의 정확성・완전성을 보증하는 것은 아닙니다. 또한, 인터넷의 특성 등으로 인해 본 앱상의 정보와 실제 정보 간에 시차 등이 생길 수 있습니다.",
  "TermsDetail.paragraph7_3": "사가미 철도는 다음 중 어느 하나에 해당하는 경우에는, 이용자에게 사전의 통지 없이 본 앱의 전부 또는 일부의 제공을 정지 또는 중단할 수 있는 것으로 합니다.",
  "TermsDetail.paragraph7_3_1": "시스템의 점검 또는 보수를 긴급히 실시하는 경우",
  "TermsDetail.paragraph7_3_2": "컴퓨터, 통신회선 등이 사고나 제삼자의 공격으로  인해 정지한 경우",
  "TermsDetail.paragraph7_3_3": "지진, 낙뢰, 화재 등의 불가항력으로 본 앱을 운영할 수 없게 된 경우",
  "TermsDetail.paragraph7_3_4": "사가미 철도가 본 앱의 운영에 이용하는 시설 등에서 전기 통신 서비스 또는 인터넷 프로바이더의 사정 등으로 통신 불능이 된 경우",
  "TermsDetail.paragraph7_3_5": "그 외, 사가미 철도가 정지 또는 중단을 할 필요가 있다고 판단한 경우",
  "TermsDetail.paragraph7_4": "사가미 철도는 이용자가 본 앱을 이용 또는 본 앱을 이용할 수 없었던 것으로 인하여 이용자 또는 제삼자에게 발생한 손해에 대해 아무런 책임을 지지 않습니다.",
  "TermsDetail.article8": "제8조 금지 사항",
  "TermsDetail.paragraph8_1": "본 앱을 이용할 때는 다음에 정하는 행위(이를 유발하는 행위나 준비 행위를 포함)를 금지합니다.",
  "TermsDetail.paragraph8_1_1": "사가미 철도 또는 제삼자를 가장하는 행위(위장 행위)",
  "TermsDetail.paragraph8_1_2": "본 앱으로 전송되는 영상, 음성, 문자 등, 소프트웨어, 그 외 본 앱에 관련한 정보를 저작권법으로 인정된 사적 이용의 범위를 넘어 전재, 복사, 복제, 출판, 상영, 양도, 개변, 공중 송신, 송신 가능화하여, 그 외의 형태로 이용하는 행위, 그 외 모든 2차 이용을 하는 행위",
  "TermsDetail.paragraph8_1_3": "역컴파일, 역어셈블, 리버스 엔지니어링에 의한 소스 코드, 구조나 사양을 해석 또는 개변하는 행위",
  "TermsDetail.paragraph8_1_4": "본 앱과 관련된 권리, 의무의 전부 또는 일부의 양도, 임대 또는 제삼자에게 이전하는 행위",
  "TermsDetail.paragraph8_1_5": "사가미 철도 또는 제삼자의 통신설비, 컴퓨터, 그 외의 기기 및 소프트웨어에 부정하게 액세스하거나, 또는 이들의 이용 혹은 운용에 지장을 주는 행위, 혹은 그러할 우려가 있는 행위",
  "TermsDetail.paragraph8_1_6": "사가미 철도 또는 제삼자의 지적 재산권, 그 외의 권리를 침해하는 행위 또는 침해할 우려가 있는 행위",
  "TermsDetail.paragraph8_1_7": "공서양속에 반하는 행위, 위법행위 또는 그 우려가 있는 행위",
  "TermsDetail.paragraph8_1_8": "선거 활동 또는 이와 유사한 행위, 그 외의 정치 및 종교에 관한 행위",
  "TermsDetail.paragraph8_1_9": "사실과 다른 정보 또는 그 우려가 있는 정보를 사가미 철도나 다른 이용자 또는 제삼자에게 제공하는 행위",
  "TermsDetail.paragraph8_1_10": "본 앱에 관련하여 영리를 목적으로 하는 행위 또는 그 준비를 목적으로 하는 행위",
  "TermsDetail.paragraph8_1_11": "본 앱의 제공 및 운영을 방해 또는 비방하는 행위",
  "TermsDetail.paragraph8_1_12": "다른 이용자에 관한 정보를 수집하거나 축적하는 행위",
  "TermsDetail.paragraph8_1_13": "본 앱에 관련하여, 다음 조에 규정하는 반사회적 세력 또는 이와 밀접하게 관계가 있는 사람에게 직간접적으로 이익을 제공하는 행위",
  "TermsDetail.paragraph8_1_14": "본 앱의 운영을 방해하는 행위 또는 사가미 철도가 부적절하다고 판단하는 행위",
  "TermsDetail.paragraph8_2": "이용자가 전항 각호의 금지 사항에 해당하는 행위를 한 경우,　사가미 철도는 해당 이용자에 대해 본 앱의 이용을 정지할 수 있습니다. 더불어 당사는 해당 이용의 정지에 관하여 아무런 책임을 지지 않는 것으로 합니다.",
  "TermsDetail.article9": "제9조 반사회적 세력의 배제",
  "TermsDetail.paragraph9_1": "이용자는 사가미 철도에 대해 자기가 폭력 단원, 폭력단 관련 기업・단체, 그 외의 반사회적 세력 또는 그 관계자는 아닌 것을 표명하고 보증한 다음 본 앱을 이용하는 것으로 합니다.",
  "TermsDetail.article10": "제10조 이력 정보의 취득",
  "TermsDetail.paragraph10_1": "사가미 철도는 본 앱을 통해 휴대 단말기의 개체식별정보(개인 및 단말기를 특정하는 정보 등)를 취득하지 않습니다.",
  "TermsDetail.paragraph10_2": "사가미 철도는 이용자로부터 다음의 정보(이하 ‘이력 정보’라고 함)를 수집하여 본 앱의 개량과 편리성의 향상, 본 앱과 관련한 새로운 서비스의 검토, 본 앱과 관련한 콘텐츠의 추천을 목적으로 이용할 수 있습니다.",
  "TermsDetail.paragraph10_2_1": "본 앱의 이용 일시",
  "TermsDetail.paragraph10_2_2": "본 앱의 이용 방법",
  "TermsDetail.paragraph10_2_3": "본 앱의 이용 환경(본 앱을 이용한 위치 정보, OS 종별 및 버전, 브라우저 종별, 이용 모바일 기종, cookie 및 JavaScript가 ON인 것 등의 정보)",
  "TermsDetail.paragraph10_3": "사가미 철도는 이력 정보를 통계 데이터로 가공하여, 소테츠 그룹 각 사 및 협력 회사에 제공하는 경우가 있습니다.",
  "TermsDetail.article11": "제11조 My 역에 대하여 ",
  "TermsDetail.paragraph11_1": "이용자는 본 앱의 일부를 이용하는 경우, My 역에 등록해야 합니다.",
  "TermsDetail.paragraph11_2": "My 역에 등록한 이용자는 언제든 My 역에 등록한 정보를 변경, 삭제할 수 있습니다.",
  "TermsDetail.article12": "제12조 개인정보의 취급",
  "TermsDetail.paragraph12_1": "이용자가 사가미 철도에 대해 개인정보를 제공하는 경우의 개인정보의 취급에 대해서는, 본 규약 이외에 소테츠 그룹 홈 페이지에 게재한 “{groupPolicyLink}”이 적용됩니다.",
  "TermsDetail.paragraph12_1_group_policy": "소테츠 그룹 개인정보 보호 방침",
  "TermsDetail.paragraph12_2": "사가미 철도는 본 규약에서 규정하는 정보의 시스템 관리를 외부에 위탁하고 있으며, 동시에 개인 정보를 위탁처에 예탁하고 있습니다. 위탁처에서 이용자의 개인정보 보호와 관리가 적절히 실시되고 있는 것을 사가미 철도의 책임으로 감독합니다.",
  "TermsDetail.paragraph12_3": "제 15조에서 규정하는 정기권 QR 예약 시스템에서 등록하신 개인정보는 서버 ID와 SSL에 의한 암호화 통신을 이용하여 사가미 철도의 서버로 안전하게 전송됩니다. 또한 스마트폰, 태블릿의 이용 환경에 따라서는 암호화되지 않은 개인정보가 캐시 데이터로서 스마트폰, 태블릿에 저장되는 경우가 있습니다. 개인정보를 입력하신 후에는 취급에 각별히 주의하시기 바랍니다.",
  "TermsDetail.article13": "제13조 푸시 알림 기능에 대하여",
  "TermsDetail.paragraph13_1": "본 앱은 푸시 알림 기능(본 앱 상에서 이용자에게 알릴 필요가 있을 때 앱 측에서 자동으로 통지하는 기능)을 가집니다. 이용자가 푸시 알림 기능을 이용하는 경우는 설정 화면에서 푸시 알림 기능을 ON으로 해 주십시오. 해당 설정은 언제든 변경할 수 있습니다.",
  "TermsDetail.paragraph13_2": "사가미 철도는 푸시 알림 기능에 관한 이용자의 이력 정보를 제10조 제2항에서 규정하는 목적으로 이용할 수 있습니다.",
  "TermsDetail.article14": "제14조 역 전경에 대하여",
  "TermsDetail.paragraph14_1": "본 앱은 역 전경 기능(역 혼잡 상황의 화상 전송)을 가집니다. 혼잡 상황의 화상 데이터는 개인 정보 보호의 관점에서 역 구내에 설치된 앱 전용 카메라의 화상을 데이터 가공 기술로 해석해 무인 개찰구 화상 (배경 화상)에 인간형 아이콘을 배치한 후, 익명 정보로서 사가미 앱에 전송하고 있습니다. 더불어 화상 등은  일체 저장하지 않습니다.",
  "TermsDetail.article15": "제 15조 정기권 QR 예약 시스템에 대하여",
  "TermsDetail.paragraph15_1": "본 앱은 정기권 QR 예약 시스템(이하 '본 서비스'라고 함)에 링크되어 있습니다. 본 서비스에서는 예약 완료 시에 소테츠선 앱으로부터 푸시 알림이 송신됩니다. 구매할 때 필요한 QR코드가 포함되어 있으므로 푸시 알림을 수신할 수 있도록 설정한 후에 이용해 주십시오.",
  "TermsDetail.paragraph15_2": "본 서비스의 이용 고객은 정기권 신규 예약 시에 표시되는 주의 사항 '본 서비스 이용에 관하여' 및 당사 공식 홈페이지 '정기권 이용 안내'의 내용에 동의한 것으로 간주합니다.",
  "TermsDetail.article16": "제16조 대상 OS",
  "TermsDetail.paragraph16_1": "사가미 앱의 대상이 되는 OS는 다음과 같습니다. 또한 대상 OS에서도 일부 작동하지 않는 경우가 있습니다.",
  "TermsDetail.paragraph16_1_ios": "iOS 10 이상 ",
  "TermsDetail.paragraph16_1_android": "Android 5 이상",
  "TermsDetail.article17": "제17조 본 규약의 변경",
  "TermsDetail.paragraph17_1": "사가미 철도는 본 규약의 내용을 이용자의 승낙을 얻지 않고 예고 없이 변경할 수 있습니다. 이 경우, 사가미 철도는 그 사실을 본 앱의 화면상에 표시합니다. 표시 후에 이용자가 본 앱을 이용함으로써, 이용자는 변경 후의 규약에 동의한 것으로 간주합니다. 이용자가 변경 후의 본 규약에 동의할 수 없는 경우는, 즉시 본 앱의 이용을 정지해야 합니다.",
  "TermsDetail.article18": "제18조 준거법 및 합의 관할",
  "TermsDetail.paragraph18_1": "본 앱의 이용과 본 규약의 해석은 일본국의 법률에 준거합니다. 본 앱의 이용에 관해 발생한 소송은 요코하마 지방재판소를 제１심의 전속적 합의 관할재판소로 합니다.",
  "TermsDetail.signatureName": "사가미 철도 주식회사",
  "TermsDetail.signatureDate": "2020년 3월 18일(개정판)",
  "ContactDetail.title": "소테츠에 관한 문의나 의견・요청사항은",
  "ContactDetail.body1": "소테츠 고객센터",
  "ContactDetail.body2": "TEL 045-319-2111 9:00~19:00(토・일・공휴일은 9:00~17:00, 12월 30일부터 1월 3일은 휴업)",
  "ContactDetail.body3": "FAX 045-319-2191",
  "ContactDetail.footer1": "자세한 내용은 ",
  "ContactDetail.footerHere": "여기를",
  "ContactDetail.footer2": " 터치해 주십시오.",

  // titles for navite app
  "PageTitle.StationDetail": '역 정보',
  "PageTitle.StationView": '역 전경',
  "PageTitle.TrainPositions": '열차 주행 위치',
  "PageTitle.RouteMap": '노선도',
}

export default ko_KR
